import { CollectionType } from '@/enums/collection-type';
import { WebLocale } from '@/enums/web-locale';
import { JWTVLP, Watchlist } from '@/lazy-load-components';
import { PageType } from '@/routing/config';
import { RouteConfig } from 'vue-router';

export const rentalListLocales = [WebLocale.au, WebLocale.nz, WebLocale.uk, WebLocale.us] as const;
export const jwtvLpLocales = [WebLocale.au, WebLocale.nz];
export type RentalListLocale = (typeof rentalListLocales)[number];

const isRentalListLocale = (locale: WebLocale) => {
	return rentalListLocales.includes(locale as RentalListLocale);
};

export function makeRentalListRoutes(currentLocale: WebLocale): RouteConfig[] {
	const routes: RouteConfig[] = [];

	if (isRentalListLocale(currentLocale)) {
		routes.push(makeRentalListsRoute(currentLocale as RentalListLocale));
	}

	if (jwtvLpLocales.includes(currentLocale)) {
		routes.push(makeJwtvLPRoute(currentLocale as RentalListLocale));
	}

	return routes;
}

function makeRentalListsRoute(currentLocale: RentalListLocale): RouteConfig {
	return {
		name: 'app.titles.my-rentals.list',
		path: `/${currentLocale}/lists/my-rentals`,
		component: Watchlist,
		meta: {
			collectionType: CollectionType.MY_RENTALS,
			tab: 'lists',
			hasFilterBar: false,
		},
	};
}

function makeJwtvLPRoute(currentLocale: RentalListLocale): RouteConfig {
	return {
		name: 'app.jwtv.landing-page',
		path: `/${currentLocale}/watch`,
		component: JWTVLP,
		meta: {
			tab: 'watch',
			pageType: PageType.WATCH,
		},
	};
}
